<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Master Item Category/Group 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="7">
          <b-form-group label-cols=2 label="Posting Group">
              <b-row>
                <b-col class="pr-1" cols="4"><b-form-input v-model="tblData.kode" placeholder="Code"></b-form-input></b-col>
                <b-col class="pr-1" cols="8"><b-form-input v-model="tblData.nama" placeholder="Name"></b-form-input></b-col>
              </b-row>
          </b-form-group>
        </b-col>
        <b-col lg="5">
          <b-form-group label-cols=1 label="Account">
              <b-row>
                <b-col class="pr-1" cols="4"><b-form-input v-model="tblData.Account" placeholder="Account Code"></b-form-input></b-col>
                <b-col cols="8">
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" size="sm"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
                </b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="8" lg="6">
        <b-card >
            <div slot="header">Item Category - Add/Edit Form 
              <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
              </div>
            </div>
              <b-form-group label-cols=3  label="Head Category">
                  <b-form-select class="input-group-text" v-model="frmdata.headcategory" :state="!$v.frmdata.headcategory.$error" :plain="true" :options="headcategories" ></b-form-select>
              </b-form-group>
              <!-- <b-form-group  label-cols=3  label="Group Code" >
                  <b-form-input v-model="frmdata.kode" :state="!$v.frmdata.kode.$error"></b-form-input>
              </b-form-group> -->
              <b-form-group  label-cols=3  label="Group Name" >
                  <b-form-input v-model="frmdata.nama" :state="!$v.frmdata.nama.$error"></b-form-input>
              </b-form-group>
              <!-- <b-form-group label-cols=3  label="Inventory Account">
                  <b-input-group >
                      <b-form-input readonly v-model="frmdata.invenDbInfo" :state="!$v.frmdata.invenDbAcc.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('invenDb')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group> -->
              <!-- <b-form-group label-cols=3  label="COGS Account">
                  <b-input-group >
                      <b-form-input readonly v-model="frmdata.invenCrInfo" :state="!$v.frmdata.invenCrAcc.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('invenCr')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group> -->
              <!-- <b-form-group label-cols=3  label="Labeled as Fixed asset ">
                <b-form-radio-group class="mt-2" v-model="frmdata.invLabel" name="radioLabel">
                  <b-form-radio value="1">Yes (Inventory Labeled)</b-form-radio>
                  <b-form-radio value="0">No</b-form-radio>
                </b-form-radio-group>
              </b-form-group> -->
        </b-card>
      </b-col>
    </b-row>
    
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
  </div>
</template>


<script>
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import itemcategory from "../../apis/itemcategory";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        // kode: { required },
        nama: { required },
        // invenDbAcc: { required },
        // invenCrAcc: { required },
        headcategory : { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      showFilter:false,
      lkuCoaShow:false,
      lkuCoaCaller:'invenDbAcc',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      frmdata:{invenDbAcc: '',invenCrAcc: '' , headcategory:'', invLabel:0},
      headcategories:[],
      tblData: {
        items: [],
        page: 1,
        limit: 10,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
      },
    };
  },
  components: {lkuCoa},
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "nama",
            label: "Item Cataegory/Group",
            sortable: true
          },
          {
            key: "headcategory",
            label: "Head Category/Group",
            sortable: true
          },
          // {
          //   key: "kode",
          //   label: "Group Code",
          //   sortable: true
          // },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function() {
      this.headcategories = await itemcategory.headcategory();
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await itemcategory.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.Account= '';
        this.tblData.nama=  '';
        this.tblData.kode=  '';
        this.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      // this.frmdata.grouplama = data.groupname;
      // this.frmdata.kodelama = data.kodeacc;
      // this.frmdata.invenDbAccInfo = data.invenDbAcc;
      // this.frmdata.invenCrAccInfo = data.invenCrAcc;
      // this.frmdata.PrePaymDbAccInfo = data.PrePaymDbAcc;
      // let _selected;
      // try {
      //   if (data.invenDbAcc) {
      //     _selected = await itemcategory.findcoa({kodeacc: data.invenDbAcc, tahun: this.tahun});
      //     this.frmdata.invenDbInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      //   if (data.invenCrAcc) {
      //     _selected = await itemcategory.findcoa({kodeacc: data.invenCrAcc, tahun: this.tahun});
      //     this.frmdata.invenCrInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      //   if (data.PrePaymDbAcc) {
      //     _selected = await itemcategory.findcoa({kodeacc: data.PrePaymDbAcc, tahun: this.tahun});
      //     this.frmdata.PrePaymDbInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      // } catch (error) {
      //   if (error.message) {
      //       toastr.error(error.message);
      //   } else {
      //       toastr.error(JSON.stringify(error));
      //   }                      
      // }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              await itemcategory.save(this.frmdata);
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await itemcategory.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.frmdata[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata[`${this.lkuCoaCaller}Acc`] = _selected.kodeacc;
            this.frmdata[`${this.lkuCoaCaller}Name`] = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
